function changePhoto (el, binding, node) {
    el.style.backgroundImage = 'url(' + binding.value + ')';
};

export default {
    inserted: function (el, binding, node) {
        changePhoto(el, binding, node);
    },
    update: function (el, binding, node) {
        changePhoto(el, binding, node);
    },
    unbind: function (el, binding, node) {
        el.style.backgroundImage = null;
    }
};



// WEBPACK FOOTER //
// ./src/components/directives/imageSrc.js